module.exports = __webpack_public_path__ + "media/images/self_employed_inactive-bf7a637c.svg";